import { types } from 'mobx-state-tree';

export const Validations = types.model('validations', {
  id: types.maybe(types.number),
  itemId: types.maybe(types.number),
  validationTypeId: types.maybe(types.number),
  validationValue: types.maybe(types.boolean),
  // blacklistCategoryFailed: types.maybe(types.boolean),
  // blacklistFailed: types.maybe(types.boolean),
  // id: types.maybe(types.number),
  // itemId: types.maybe(types.number),
  // veroFailed: types.maybe(types.boolean)
});
